export const themeCookieName = "amazona_theme";
export const themes = ["dark", "light"] as const;
export type Theme = (typeof themes)[number];

export function isTheme(value: string | undefined | null): value is Theme {
  return value === "dark" || value === "light";
}

